/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';

export interface AgoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequest {
    /**
     * 
     */
    portfolioId: string;
    /**
     * Optional Parameter of agora ids (can be Agora ID (IT-PRP-XX12345-2025) or CRM submission id (SUB-123456-X1X2X3)
     */
    agoraIds?: Array<string>;
    /**
     * Optional parameter to force expiring data fetch
     */
    forceExpiring?: boolean;
    /**
     * Optional parameter to force renewal data fetch
     */
    forceRenewal?: boolean;
}

export interface StartQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequest {
    /**
     * 
     */
    portfolioId: string;
    /**
     * Parameter for uwy
     */
    uwy?: number;
    /**
     * Optional parameter using support_data
     */
    withSupportData?: boolean | null;
    /**
     * Optional parameter using volatility_data excel file
     */
    withVolatilityData?: boolean | null;
    /**
     * Optional parameter using submission list excel file
     */
    submissionListPath?: string | null;
}

export interface StartQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequest {
    /**
     * 
     */
    portfolioId: string;
    /**
     * Parameter for uwy
     */
    uwy?: number;
    /**
     * Optional Parameter of agora ids (can be Agora ID (IT-PRP-XX12345-2025) or CRM submission id (SUB-123456-X1X2X3)
     */
    agoraIds?: Array<string> | null;
    /**
     * Optional parameter using support_data
     */
    withSupportData?: boolean | null;
    /**
     * Optional parameter using volatility_data excel file
     */
    withVolatilityData?: boolean | null;
    /**
     * Optional parameter add new accounts
     */
    addNewAccounts?: boolean | null;
    /**
     * Optional parameter using submission list excel file
     */
    submissionListPath?: string | null;
    /**
     * Optional parameter using expiring modification date
     */
    expiringModificationDate?: Date | null;
    /**
     * Optional parameter using renewal modification date
     */
    renewalModificationDate?: Date | null;
}

/**
 * 
 */
export class TechExAGORAAPIsApi extends runtime.BaseAPI {

    /**
     * Creates request options for agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPost without sending the request
     */
    async agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequestOpts(requestParameters: AgoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError(
                'portfolioId',
                'Required parameter "portfolioId" was null or undefined when calling agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agoraIds'] != null) {
            queryParameters['agora_ids'] = requestParameters['agoraIds'];
        }

        if (requestParameters['forceExpiring'] != null) {
            queryParameters['force_expiring'] = requestParameters['forceExpiring'];
        }

        if (requestParameters['forceRenewal'] != null) {
            queryParameters['force_renewal'] = requestParameters['forceRenewal'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/agora/etl/tracking/agorafetch/{portfolio_id}`;
        urlPath = urlPath.replace('{portfolio_id}', encodeURIComponent(String(requestParameters['portfolioId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Agora Fetch
     */
    async agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRaw(requestParameters: AgoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Agora Fetch
     */
    async agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPost(requestParameters: AgoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.agoraFetchAgoraEtlTrackingAgorafetchPortfolioIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dbHealthCheckAgoraAgoraDbsynHealthGet without sending the request
     */
    async dbHealthCheckAgoraAgoraDbsynHealthGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/agora/dbsyn/health`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Db Health Check Agora
     */
    async dbHealthCheckAgoraAgoraDbsynHealthGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.dbHealthCheckAgoraAgoraDbsynHealthGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Db Health Check Agora
     */
    async dbHealthCheckAgoraAgoraDbsynHealthGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.dbHealthCheckAgoraAgoraDbsynHealthGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dbHealthCheckPfmAgoraDbpfmHealthGet without sending the request
     */
    async dbHealthCheckPfmAgoraDbpfmHealthGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/agora/dbpfm/health`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Db Health Check Pfm
     */
    async dbHealthCheckPfmAgoraDbpfmHealthGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.dbHealthCheckPfmAgoraDbpfmHealthGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Db Health Check Pfm
     */
    async dbHealthCheckPfmAgoraDbpfmHealthGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.dbHealthCheckPfmAgoraDbpfmHealthGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPost without sending the request
     */
    async startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequestOpts(requestParameters: StartQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError(
                'portfolioId',
                'Required parameter "portfolioId" was null or undefined when calling startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uwy'] != null) {
            queryParameters['uwy'] = requestParameters['uwy'];
        }

        if (requestParameters['withSupportData'] != null) {
            queryParameters['with_support_data'] = requestParameters['withSupportData'];
        }

        if (requestParameters['withVolatilityData'] != null) {
            queryParameters['with_volatility_data'] = requestParameters['withVolatilityData'];
        }

        if (requestParameters['submissionListPath'] != null) {
            queryParameters['submission_list_path'] = requestParameters['submissionListPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/agora/etl/tracking/initial/{portfolio_id}`;
        urlPath = urlPath.replace('{portfolio_id}', encodeURIComponent(String(requestParameters['portfolioId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start Query Execution
     */
    async startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRaw(requestParameters: StartQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Start Query Execution
     */
    async startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPost(requestParameters: StartQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.startQueryExecutionAgoraEtlTrackingInitialPortfolioIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPost without sending the request
     */
    async startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequestOpts(requestParameters: StartQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['portfolioId'] == null) {
            throw new runtime.RequiredError(
                'portfolioId',
                'Required parameter "portfolioId" was null or undefined when calling startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uwy'] != null) {
            queryParameters['uwy'] = requestParameters['uwy'];
        }

        if (requestParameters['agoraIds'] != null) {
            queryParameters['agora_ids'] = requestParameters['agoraIds'];
        }

        if (requestParameters['withSupportData'] != null) {
            queryParameters['with_support_data'] = requestParameters['withSupportData'];
        }

        if (requestParameters['withVolatilityData'] != null) {
            queryParameters['with_volatility_data'] = requestParameters['withVolatilityData'];
        }

        if (requestParameters['addNewAccounts'] != null) {
            queryParameters['add_new_accounts'] = requestParameters['addNewAccounts'];
        }

        if (requestParameters['submissionListPath'] != null) {
            queryParameters['submission_list_path'] = requestParameters['submissionListPath'];
        }

        if (requestParameters['expiringModificationDate'] != null) {
            queryParameters['expiring_modification_date'] = runtime.serializeDateTime(requestParameters['expiringModificationDate'] as any);
        }

        if (requestParameters['renewalModificationDate'] != null) {
            queryParameters['renewal_modification_date'] = runtime.serializeDateTime(requestParameters['renewalModificationDate'] as any);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/agora/etl/tracking/partial/{portfolio_id}`;
        urlPath = urlPath.replace('{portfolio_id}', encodeURIComponent(String(requestParameters['portfolioId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start Query Execution
     */
    async startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRaw(requestParameters: StartQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Start Query Execution
     */
    async startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPost(requestParameters: StartQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.startQueryExecutionAgoraEtlTrackingPartialPortfolioIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
